module.exports = __webpack_public_path__ + "img/logo.535ae73d.svg";